const projectRouter = {
  route: null,
  name: null,
  title: '项目管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  isElementIcon: false,
  filePath: 'view/dict/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '全部项目',
      type: 'view',
      name: 'projectList',
      route: '/project/list',
      filePath: 'view/project/project-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
      isElementIcon: false,
      permission: ['全部项目'],
    },
    // {
    //   title: '我的项目',
    //   type: 'view',
    //   name: 'myProjectList',
    //   route: '/project/my/list',
    //   filePath: 'view/project/project-list.vue',
    //   inNav: false,
    //   icon: 'iconfont icon-add',
    //   isElementIcon: false,
    // },
  ],
}

export default projectRouter
